<template>
    <div>
        <HeadlineContainer headline="Tags" :breadcrumbs="[{text: 'Tags'}]">
            <div class="btn-group">
                <router-link to="/tags/create" class="btn btn-white" >
                    <i class="fa fa-plus"></i> Create
                </router-link>
            </div>
        </HeadlineContainer>

        <div class="container">
            <TagList/>
        </div>
    </div>
</template>

<script>
import TagList from '../../../components/Administration/Tags/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'

export default {
    components: {TagList, HeadlineContainer},
}
</script>
